import React from 'react';
import {useStyles} from '../../../../shared/hooks/styles';
import {View} from 'react-native';
import {IStateProps} from './model';
import {Accordion} from '../../../../shared/components/accordion';
import {Markdown} from '../../../../shared/components/markdown';
import CreateStyles from './styles';

export default ({questions}: IStateProps) => {
  const styles = useStyles((helper) => CreateStyles(helper));

  return (
    <View>
      {questions.map((item, index) => (
        <Accordion
          index={index}
          key={item.id}
          variant='outlined'
          contentCustomStyle={styles.accordionContent}
          title={item.name}>
          <View>
            {item.answerMarkdown ? (
              <View style={styles.answerText} testID={`question-answer-${index}`}>
                <Markdown>{item.answerMarkdown}</Markdown>
              </View>
            ) : null}
          </View>
        </Accordion>
      ))}
    </View>
  );
};
